
define('text!modules/audiences/onboarding/create/templates/otherData/agencies.html',[],function () { return '<div class="col-1-4">\n  <strand-header size="small">Agency</strand-header>\n  <strand-dropdown disabled id="agencies" fitparent name="dropdown" placeholder="Select One">\n    <strand-input search clear placeholder="Search"></strand-input>\n  </strand-dropdown>\n</div>';});

